import type { FaireProductEntity } from "../../entity_types/product";

export const p_55xmcrzfva: FaireProductEntity = {
  token: "p_55xmcrzfva",
  type: "product",
  name: "Dainty Sun Moon Opal Charm Layering Necklace in Solid Copper",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/6aca55fc71c089473f1425e004d194183e37be2a28af1461be459fa531f1bc36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ccdb9a7fd2b5cfac32f1db54646c67bac9f7e601066465b7ca103cfd71fc00c7.jpeg",
    "https://cdn.faire.com/fastly/0e8e645010b3c559c427db74be936493b057ea237a16b125154d88085fb59013.jpeg",
    "https://cdn.faire.com/fastly/94eee749cc2bb4d3ca785de44319e511fb798a1bc0d49baca59d6c5171db0417.jpeg",
    "https://cdn.faire.com/fastly/2f2ee0897b1a29837313c161e2c6a3d43c1efea5a6555491e7cdf7c76ca704d2.jpeg",
    "https://cdn.faire.com/fastly/2c388a94d5d464ab87202935860120a57026a9343f290e40d4523ffbe1342552.jpeg",
    "https://cdn.faire.com/fastly/52cae1b6a55ade08b93fcf7dc00e087c86f5af4a2c95d2909324738664478cdf.png",
    "https://cdn.faire.com/fastly/ee4ea6b83024b1d9264481fc480d3c88dad89c6899629a1759e33b961b3e12f2.png",
    "https://cdn.faire.com/fastly/38fbd5b3de0a9cd0fbf343e3e21c67795dfd575259f013192bf26a02b819c6cd.png",
    "https://cdn.faire.com/fastly/425f069891c9b343b6cb7914dbd43435af2d55aa3b9a1b52ae667a8362941e7d.png",
  ],
  priceDollars: 9.5,
  description:
    "Description & Details\n\nThe moon, sun, and stars became the representations of gods and goddesses throughout the years as ways to explain their presence and permanence.\n\n• Material:  High Quality Copper ∙ Opal\n• Finish: Hypoallergenic ∙ Gold Plating \n• Dimensions: 25 mm sun charm, 18 - 21 inch chain, 10 mm moon charm, 15 - 18 inch chain \n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:55.410Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
